import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { FollowUpRule } from '../queries';
import { FollowUpForm } from './FollowUpForm';

interface Props {
  open: boolean;
  agencyId: number;
  rule?: FollowUpRule;
  onClose: () => void;
}

export const FollowUpModal = ({ open, agencyId, rule, onClose }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen scroll="body">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {rule ? 'Edit follow-up rule' : 'Create follow-up rule'}
        <IconButton onClick={onClose}>
          <CloseIcon color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FollowUpForm agencyId={agencyId} rule={rule} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};
